import { observer } from 'mobx-react';
import { useProfileWidgetStore } from './StoreProvider';
import { CentreModal } from '../../../../../components/Modals';
import { LoaderButton } from '../../../../../libs/ui-kit/buttons/LoaderButton';
import Button from 'react-bootstrap/Button';
import React from 'react';
import { Badge } from 'react-bootstrap';

export const RevocationModal = observer(() => {
  const store = useProfileWidgetStore();

  return (
    <CentreModal
      isShow={store.revocationModal.isVisible}
      title="Отзыв персональных данных"
      onHide={store.revocationModal.hide}>
      <div className="text-muted">Пользователь</div>
      <div className="mb-4">{store.profile?.fullName}</div>
      <Badge variant="danger" className="mb-4">
        Внимание! Вы не сможете отменить операцию.
      </Badge>
      <div className="d-flex">
        <div className="mr-1 d-flex" style={{ width: '136px' }}>
          <LoaderButton
            variant="success"
            onClick={store.onRevocationPersonalDataClick}
            isLoading={store.revocationPersonalDataInProgress}>
            Выполнить
          </LoaderButton>
        </div>
        <Button
          disabled={store.revocationPersonalDataInProgress}
          variant="light"
          className="mx-1"
          onClick={store.revocationModal.hide}>
          Отменить
        </Button>
      </div>
    </CentreModal>
  );
});
